import { render, staticRenderFns } from "./afterOrder.vue?vue&type=template&id=72ffa4e7"
import script from "./afterOrder.vue?vue&type=script&lang=js"
export * from "./afterOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports